import { memo } from 'react';

import { EyeOffIcon } from '@air/design-icons';

import { SearchToken } from '~/components/SearchBar/SearchToken';
import { SEARCH_BOARD_TOKEN } from '~/constants/testIDs';
import { useIsFlattenedView } from '~/hooks/search/useIsFlattenedView';

type FlattenedBoardSearchTokenProps = {
  boardName?: string;
};

export const FlattenedBoardSearchToken = memo(({ boardName }: FlattenedBoardSearchTokenProps) => {
  const { setIsFlattenedView } = useIsFlattenedView();

  return (
    <SearchToken
      testId={SEARCH_BOARD_TOKEN}
      tooltipText={`${boardName} (expanded)`}
      icon={<EyeOffIcon className="mr-1 shrink-0 ads:text-icon-primary text-blue-11" size="xs" />}
      tokenName={boardName}
      color="blue"
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onCloseClick={() => {
        setIsFlattenedView(false);
      }}
    />
  );
});

FlattenedBoardSearchToken.displayName = 'FlattenedBoardSearchToken';
